import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    
    // 1. Der optimierte Netzwerk-Spion
    const { fetch: originalFetch } = window;
    window.fetch = async (...args) => {
      const response = await originalFetch(...args);
      
      // Nur reagieren, wenn es ein erfolgreicher Add-to-Cart ist
      if (args[0] && typeof args[0] === 'string' && args[0].includes('/cart/add') && response.ok) {
        // Wir holen uns die Daten direkt aus der Antwort, um einen extra Request zu sparen
        const responseClone = response.clone();
        responseClone.json().then(cartData => {
          console.log("StillType: Produkt erfolgreich hinzugefügt.");
          // Kleiner Delay, damit die "Kugel" Zeit hat zu fliegen
          setTimeout(() => this.refreshAndOpen(), 400); 
        });
      }
      return response;
    };

    // 2. Event-Listener für manuelle Trigger
    document.addEventListener(CartAddEvent.eventName, () => this.refreshAndOpen());
  }

  async refreshAndOpen() {
    const sectionId = 'cart-drawer'; 

    try {
      // Nutze die Section Rendering API von Shopify
      const response = await fetch(`${window.location.pathname}?sections=${sectionId}`);
      const data = await response.json();

      if (data && data[sectionId]) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data[sectionId], 'text/html');
        
        // Suche gezielt nach dem Inhalt innerhalb von cart-items-component
        const freshItems = doc.querySelector('cart-items-component');
        const currentItems = this.querySelector('cart-items-component');

        if (freshItems && currentItems) {
          // Nur den inneren Teil austauschen für weniger "Flackern"
          currentItems.innerHTML = freshItems.innerHTML;
          
          // Falls sich der Header oder Footer (Preise) auch ändern muss:
          this.updateFooter(doc);
          
          console.log("StillType: Warenkorb-Inhalt aktualisiert.");
        } else {
          // Fallback: Alles austauschen
          this.innerHTML = doc.body.firstElementChild.innerHTML;
        }
      }
    } catch (e) {
      console.error("StillType: Fehler beim AJAX-Update:", e);
    }

    // Drawer öffnen
    if (this.hasAttribute('auto-open')) {
      this.open();
    }
  }

  updateFooter(htmlDoc) {
    const freshFooter = htmlDoc.querySelector('.cart-drawer__footer');
    const currentFooter = this.querySelector('.cart-drawer__footer');
    if (freshFooter && currentFooter) {
      currentFooter.innerHTML = freshFooter.innerHTML;
    }
  }

  open() { 
    // Sicherstellen, dass der Dialog existiert und die show-Methode der Basisklasse nutzt
    if (this.showDialog) {
        this.showDialog(); 
    } else {
        this.querySelector('dialog')?.showModal();
    }
  }
  
  close() { 
    if (this.closeDialog) {
        this.closeDialog();
    } else {
        this.querySelector('dialog')?.close();
    }
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}